import * as ko from 'knockout';

import {CustomFieldControl} from "../CustomFieldControl";

import Template from './Template.html';
import {ProductCustomFieldDescription} from "../../ProductCustomFieldDescription";
import {CustomFieldValue} from '../../../CustomFieldValue';
import {ProductPart} from '../../../ProductPart';

export class CustomTextControl extends CustomFieldControl {

	private _displayValue: KnockoutObservable<string>;

	constructor(customField: ProductCustomFieldDescription, productPart: ProductPart) {
		super(customField, productPart);

		this.HasContent = ko.observable(true);
		this._displayValue = ko.observable(null);
		this.SetIsReady()
	}

	get MaxInputLength() {
		return this.Size > 0 ? this.Size : -1;
	}

	GetTemplate() {
		return Template;
	}

	GetValueForSave(): CustomFieldValue {
		return new CustomFieldValue(this.Id, this._displayValue(), this.IsValid(this._displayValue()));
	}

	SetValue(customFieldValue: CustomFieldValue) {
		if (customFieldValue) {
			this._displayValue(customFieldValue.Value);
		}

		this.StartListeningValueChanges();
	}

	UpdateValue(value: string) {
		this.SetValue(new CustomFieldValue(0,value, this.IsValid(value)))
	}

	SetDefaultValue() {
		const defaultFieldValue = new CustomFieldValue(this.Id, this.DefaultValue(), this.IsValid(this.DefaultValue()));
		this.SetValue(defaultFieldValue);
	}

	ClearValue() {
		this._displayValue(null);
	}

	private StartListeningValueChanges() {
		if (this._displayValue.getSubscriptionsCount() == 0) {
			this._displayValue.subscribe(() => {
				this.CheckValidControl();
				this.OnValueChanged();
			});
		}
	}

	IsValid(value?: any): boolean {
		const valueToCheck = value ? value : this._displayValue();
		return this.GetIsRequiredValidation(valueToCheck) && this.GetSizeValidation(valueToCheck);
	}

	CheckValidControl() {
		this.isValidControl(this.GetIsRequiredValidRule(this._displayValue()) && this.GetIsSizeValidRule(this._displayValue()));
	}
}